import React__default from 'react';
import { u as useTranslations } from './index-ef9bdc70.js';
import { B as Button } from './index-7e4ea28c.js';

var styles = {"loading":"PD6nRZX"};

const Loading = ({ className, size = 'md' }) => {
    const { t } = useTranslations();
    return (React__default.createElement("div", { className: `${styles.loading} ${className}` },
        React__default.createElement(Button, { size: size, color: "transparent", isLoading: true }, t('loading'))));
};

export { Loading as L };
